// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1HJDA","vLegacy":"SelectSecondary_vLegacy__a8Z5Q","error":"SelectSecondary_error__axptQ","disabled":"SelectSecondary_disabled__p5znU"};